export { default } from './JournalHomeBlock';
